<div class="page-shell">
  <div class="stats-wrapper">
    <div class="analytics-page">
    <div class="controls-row">
      <div class="analytics-toggle-wrapper">
        <div class="toggle-card">
          <div class="toggle-header">
            <mat-icon class="toggle-icon">analytics</mat-icon>
            <span class="toggle-label">{{ 'analytics.enable' | translate }}</span>
          </div>
          <mat-slide-toggle
            #analyticsToggle
            [checked]="analyticLinksEnabled$ | async"
            (change)="toggleAnalytics($event.checked)"
            color="primary"
            class="custom-toggle"
          ></mat-slide-toggle>
        </div>
      </div>

      <div class="date-range-wrapper">
        <app-range-calendar
          [label]="'analytics.range.label' | translate"
          [dateRangeForm]="dateRangeForm"
        />
      </div>
    </div>

    <div class="clicks-section">
      <div class="clicks-card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading && totalClicks?.templateClicks !== undefined">
          <div class="number-of-clicks">{{ totalClicks?.templateClicks }}</div>
          <div class="clicks-card__label">{{ 'analytics.templateClicks' | translate }}</div>
        </ng-container>
      </div>

      <div class="clicks-card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading && totalClicks?.addonBannerClicks !== undefined">
          <div class="number-of-clicks">{{ totalClicks.addonBannerClicks }}</div>
          <div class="clicks-card__label">{{ 'analytics.addonBannerClicks' | translate }}</div>
        </ng-container>
      </div>

      <div class="clicks-card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading && totalClicks?.addonLinkClicks !== undefined">
          <div class="number-of-clicks">{{ totalClicks.addonLinkClicks }}</div>
          <div class="clicks-card__label">{{ 'analytics.addonLinkClicks' | translate }}</div>
        </ng-container>
      </div>

      <div class="clicks-card total-clicks-card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading && totalClicks?.totalClicks !== undefined">
          <div class="number-of-clicks">{{ totalClicks.totalClicks }}</div>
          <div class="clicks-card__label">{{ 'analytics.totalClicks' | translate }}</div>
        </ng-container>
      </div>

      <div class="clicks-card email-opens-card">
        <div class="dc-stats-summary__loader" *ngIf="summaryLoading">
          <app-loading [hideText]="true"></app-loading>
        </div>
        <ng-container *ngIf="!summaryLoading && totalClicks?.emailOpens !== undefined">
          <div class="number-of-clicks">{{ totalClicks?.emailOpens }}</div>
          <div class="clicks-card__label">{{ 'analytics.emailOpens' | translate }}</div>
        </ng-container>
      </div>
    </div>

    <div class="table-controls-wrapper">
      <div class="table-filter-wrapper">
        <mat-form-field appearance="outline" class="filter-field search-field" subscriptSizing="dynamic">
          <input
            matInput
            (keyup)="applyFilter($event)"
            #input
            [placeholder]="'analytics.filter.searchPlaceholder' | translate"
            [attr.aria-label]="'analytics.filter.search' | translate"
          />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
      </div>

      <div class="table-group-wrapper">
        <div class="toggle-group">
          <button
            class="toggle-btn"
            type="button"
            [class.active]="selectedResourceType === 'TEMPLATE'"
            (click)="onResourceClick('TEMPLATE')"
          >
            {{ 'analytics.usersStats.template' | translate }}
          </button>
          <button
            class="toggle-btn"
            type="button"
            [class.active]="selectedResourceType === 'BANNER'"
            (click)="onResourceClick('BANNER')"
          >
            {{ 'analytics.usersStats.banner' | translate }}
          </button>
          <button
            class="toggle-btn"
            type="button"
            [class.active]="selectedResourceType === 'LINK'"
            (click)="onResourceClick('LINK')"
          >
            {{ 'analytics.usersStats.link' | translate }}
          </button>
          <button
            class="toggle-btn"
            type="button"
            [class.active]="selectedResourceType === 'ALL'"
            (click)="onResourceClick('ALL')"
          >
            {{ 'analytics.usersStats.all' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="table-container analytics-table-container" [class.table-container--loading]="tableLoading" [class.table-container--empty]="!tableLoading && dataSource.data.length === 0">
      <mat-table
        [dataSource]="dataSource"
        matSort
        multiTemplateDataRows
      >
        <ng-container matColumnDef="expand">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              type="button"
              class="expand-btn"
              [disabled]="!element.templates?.length"
              (click)="toggleRow(element); $event.stopPropagation()"
            >
              <mat-icon>{{ element.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="userEmail">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'analytics.usersStats.user' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.userEmail }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalOpens">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'analytics.usersStats.opens' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.totalOpens }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalClicks">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'analytics.usersStats.clicks' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.totalClicks }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalCTR">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'analytics.ctr' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ formatCTR(element.totalCTR) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalAddons">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'analytics.usersStats.links' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="addons-list" *ngIf="element.totalAddons.length; else noAddons">
              <mat-chip
                class="link-chip-wrapper"
                *ngFor="let addon of element.totalAddons; trackBy: trackByResourceId"
                [class.template-chip]="addon.resourceType === 'TEMPLATE'"
                [class.addon-banner-chip]="addon.resourceType === 'ADDON_BANNER'"
                [class.addon-link-chip]="addon.resourceType === 'ADDON_LINK'"
                [class.email-open-chip]="addon.resourceType === 'EMAIL_OPEN'"
                [matTooltip]="formatResourceTooltip(addon)"
              >
                <span class="link-name">
                  {{ addon.resourceName }}
                </span>
              </mat-chip>
            </div>
            <ng-template #noAddons>
              <span class="no-addons">-</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <mat-cell *matCellDef="let detailElement" [attr.colspan]="displayedColumns.length">
            <div class="expanded-detail" [class.expanded-detail--open]="detailElement.isExpanded">
              <div class="template-rows" *ngIf="detailElement.isExpanded && detailElement.templates?.length">
                <div class="template-row" *ngFor="let template of detailElement.templates">
                  <div class="template-row__expand" aria-hidden="true"></div>
                  <div class="template-row__name">
                    <a [href]="'/signatures/custom/' + template.templateId" target="_blank" rel="noopener">
                      {{ template.templateName || template.templateId }}
                    </a>
                  </div>
                  <div class="template-row__opens">{{ template.opens || 0 }}</div>
                  <div class="template-row__clicks">{{ template.clicks }}</div>
                  <div class="template-row__ctr">{{ formatCTR(template.ctr) }}</div>
                  <div class="template-row__links">
                    <div class="addons-list" *ngIf="template.topResourceClicks?.length; else noTemplateLinks">
                      @for (click of assertColumnItemType(template).topResourceClicks; track click.resourceId + '_' + click.resourceType) {
                        @if (click.resourceName) {
                          <a
                            [href]="click.resourceType === 'TEMPLATE' || click.resourceType === 'EMAIL_OPEN' ? '/signatures/custom/' + click.resourceId : '/addons'"
                            target="_blank"
                            rel="noopener"
                          >
                            <mat-chip
                              class="link-chip-wrapper"
                              [class.template-chip]="click.resourceType === 'TEMPLATE'"
                              [class.addon-banner-chip]="click.resourceType === 'ADDON_BANNER'"
                              [class.addon-link-chip]="click.resourceType === 'ADDON_LINK'"
                              [class.email-open-chip]="click.resourceType === 'EMAIL_OPEN'"
                              [matTooltip]="formatResourceTooltip(click)"
                            >
                              <span class="link-name">
                                {{ click.resourceName }}
                              </span>
                            </mat-chip>
                          </a>
                        }
                      }
                    </div>
                    <ng-template #noTemplateLinks>
                      <span class="no-addons">-</span>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="analytics-data-row"
          [class.analytics-data-row--expanded]="element.isExpanded"
        ></mat-row>
        <mat-row
          *matRowDef="let element; columns: ['expandedDetail']"
          class="expanded-row"
          [class.expanded-row--open]="element.isExpanded"
        ></mat-row>
      </mat-table>

      <div class="loading-wrapper" *ngIf="tableLoading">
        <app-loading></app-loading>
      </div>
      <div class="empty-state" *ngIf="!tableLoading && dataSource.data.length === 0">
        <mat-icon class="empty-state__icon">bar_chart</mat-icon>
        <p>{{ 'analytics.usersStats.empty' | translate }}</p>
      </div>
    </div>
    </div>
  </div>
</div>
